"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cExternalInteractionTypeDataSchema = exports.getPostManyExternalInteractionsPayloadSchema = exports.getOneExternalInteractionSchema = exports.cAccountIdUserIdentifier = exports.cCustomIdUserIdentifier = exports.getValidationSchemaForInteractionTypeVerb = exports.cInteractionBaseSchemaPerVerb = exports.cRsvpStatus = exports.cInteractionTypeVerbSchema = void 0;
var zod_1 = require("../../zod");
var zod_2 = require("zod");
var constants_1 = require("./constants");
exports.cInteractionTypeVerbSchema = zod_2.z.enum([
    constants_1.cInteractionTypeVerbs.attended,
    constants_1.cInteractionTypeVerbs.invited,
    constants_1.cInteractionTypeVerbs.volunteered,
    constants_1.cInteractionTypeVerbs.opened,
    constants_1.cInteractionTypeVerbs.watched,
    constants_1.cInteractionTypeVerbs.RSVPed,
    constants_1.cInteractionTypeVerbs.read
]);
var cEntityIdentifierSchema = zod_2.z.object({
    entityFieldKey: zod_2.z.string().optional(),
    entityFieldValue: zod_2.z.string().optional(),
    entityId: zod_2.z.string().uuid().optional()
});
exports.cRsvpStatus = zod_2.z.enum([
    constants_1.cRsvpStatusTypes.accepted,
    constants_1.cRsvpStatusTypes.declined,
    constants_1.cRsvpStatusTypes.tentative
]);
exports.cInteractionBaseSchemaPerVerb = {
    attended: zod_2.z.object({
        attendanceType: zod_2.z
            .enum([constants_1.cAttendanceTypes['in-person'], constants_1.cAttendanceTypes.remote])
            .optional()
    }),
    RSVPed: zod_2.z.object({
        rsvpStatus: exports.cRsvpStatus
    }),
    invited: zod_2.z.object({}),
    volunteered: zod_2.z.object({}),
    opened: zod_2.z.object({}),
    watched: zod_2.z.object({}),
    read: zod_2.z.object({})
};
function getValidationSchemaForInteractionTypeVerb(verb) {
    return exports.cInteractionBaseSchemaPerVerb[verb];
}
exports.getValidationSchemaForInteractionTypeVerb = getValidationSchemaForInteractionTypeVerb;
exports.cCustomIdUserIdentifier = zod_2.z.object({
    customUserId: zod_2.z.coerce.number(),
    customUserIdValue: zod_2.z.string().max(128)
});
exports.cAccountIdUserIdentifier = zod_2.z.object({
    accountId: zod_2.z.number()
});
var getOneExternalInteractionSchema = function (opts) {
    if (opts === void 0) { opts = {}; }
    return zod_2.z.object({
        /**
         * Some way to identify the user who performed the interaction.
         * Either use some arbitrary key-value pair to identify the user,
         * specific to the service, e.g. ID1=1234 or use the user's accountId.
         */
        user: exports.cCustomIdUserIdentifier.or(exports.cAccountIdUserIdentifier),
        /**
         * The UTC date at which the interaction occurred.
         */
        utcDate: (0, zod_1.getZodUtcDateTimeSchema)({
            errorMessage: opts.errorMessage
        }),
        /**
         * Validated against the schema defined in the InteractionType.
         * This will be a combination of the schema derived from the
         * verb and of the schema specific to the InteractionType.
         */
        interactionData: zod_2.z.unknown().optional()
    });
};
exports.getOneExternalInteractionSchema = getOneExternalInteractionSchema;
var getPostManyExternalInteractionsPayloadSchema = function (opts) {
    if (opts === void 0) { opts = {}; }
    return zod_2.z.object({
        /**
         * This will roughly map to a `data source` in the insights interface:
         * something to pick from to create reports.
         */
        externalInteractionTypeId: zod_2.z.string().uuid(),
        entity: cEntityIdentifierSchema.optional(),
        interactions: zod_2.z.array((0, exports.getOneExternalInteractionSchema)(opts))
    });
};
exports.getPostManyExternalInteractionsPayloadSchema = getPostManyExternalInteractionsPayloadSchema;
// I've made the mistake of writing types instead of schemas. Needs converting.
var cInputSchema = zod_2.z.any();
exports.cExternalInteractionTypeDataSchema = zod_2.z.object({
    externalInteractionVerb: exports.cInteractionTypeVerbSchema,
    externalInteractionExtraDataValidationSchema: zod_2.z
        .array(cInputSchema)
        .optional(),
    externalInteractionExtraDataFieldIds: zod_2.z.array(zod_2.z.string()).optional()
});
